import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "../../../styles/breakpoints";
import { vars } from "../../../styles/theme.css";

export const panelContainer = style({
  display: "flex",
  flex: "1",
  flexDirection: "column-reverse",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: vars.space["2xs"],
  padding: `0 ${vars.space.xs}`,
  textAlign: "center",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      gap: vars.space.xs,
      paddingInlineStart: vars.space.m,
      paddingInlineEnd: vars.space.m,
    },
    [`screen and (min-width:${breakpoints[4]})`]: {
      alignItems: "normal",
      gap: vars.space.s,
      textAlign: "start",
      textWrap: "nowrap",
    },
  },
  selectors: {
    "&:not(:last-child)": {
      borderInlineEnd: "none",
      "@media": {
        [`screen and (min-width:${breakpoints[4]})`]: {
          borderInlineEnd: `1px solid ${vars.colors.outlineVariant}`,
        },
      },
    },
    "&:first-child": {
      paddingInlineStart: 0,
    },
    '[data-variant="transfers-basic"] &': {
      alignItems: "center",
    },
  },
});

export const panelSubHeader = style({
  marginBlock: 0,
  color: vars.colors.onSurfaceVariant,
  fontFamily: "inherit",
  fontSize: vars.fontSizes.body.s,
  fontWeight: "inherit",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      fontSize: vars.fontSizes.body.m,
    },
  },
});

const scoreboardValueBase = style({
  gap: vars.space.xs,
  borderRadius: vars.radii.s,
  padding: `${vars.space["2xs"]} 0`,
  width: "fit-content",
  textWrap: "nowrap",
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      fontSize: vars.fontSizes.body.xl,
    },
  },
});

export const scoreboardValueVariants = styleVariants({
  default: [scoreboardValueBase],
  success: [
    scoreboardValueBase,
    {
      backgroundColor: vars.colors.success,
      color: vars.colors.onPrimary,
      padding: `${vars.space["2xs"]} ${vars.space.xs}`,
    },
  ],
  error: [
    scoreboardValueBase,
    {
      backgroundColor: vars.colors.error,
      color: vars.colors.white,
      padding: `${vars.space["2xs"]} ${vars.space.xs}`,
    },
  ],
});
